module.exports = __webpack_public_path__ + "img/技术需求库banner.28066f2f.png";